<div style="
    background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;
    background-size: cover;
    height: 100vh;
    padding-top: 200px;
  ">
    <span style="color: white; float: right; margin: -7.6% 7%; position: relative;" *ngIf="(version)"> <h6>V{{version}}</h6> </span>
    <div style="
      height: 100%;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    ">
        <div style="
        background-color: white;
        padding: 16px;
        padding-bottom: 10px;
        border-radius: 8px;
        display: flex;
        align-items: center;
      ">
            <div *ngIf="!end"
                 style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
                 class="p-3">
                <span style="font-size: 50px">
                    <img src="/../../../assets/imagesNew/inactive.png"
                         alt="Warning Icon"
                         style="width: 350px; height: 240px" />
                </span>
                <h4 style="text-align: center; color: #1f4897" class="mb-2">
                    Session Timeout
                </h4>
                <h5 style="text-align: center" class="mb-0 mt-1">
                    Your session has timed out due to inactivity.
                </h5>
                <br />
                <p-button class="mt-1"
                          label="Login again"
                          styleClass="pink-btn"
                          (click)="login()"></p-button>
            </div>
            <div *ngIf="end"
                 style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
                 class="p-3">
                <span style="font-size: 50px">
                    <img src="/../../../assets/imagesNew/terminate.png"
                         alt="Warning Icon"
                         style="width: 350px; height: 250px" />
                </span>
                <h4 style="text-align: center; color: #1f4897" class="mb-2">
                    Session Timeout
                </h4>
                <h5 style="text-align: center" class="mb-0 mt-1">
                    Your session is ending because someone else has <br />logged in with
                    the same user credentials.
                </h5>
            </div>
        </div>
    </div>
</div>
